import { Button, styled, Typography } from '@mui/material';
import React from 'react';

export function BasicButtonNew(props) {
  return (
    <CustomButton
      variant={props.variant}
      size="large"
      {...props}
      sx={{
        background: props.bg,
          borderColor: props.borderColor,
        '&:focus': {
            borderColor: props.borderColor,
        },
      }}
    >
      {props.icon && (
        <img src={props.icon} alt="icon" style={{ marginRight: '6px' }} />
      )}
      <ButtonLabel
        variant="button"
        className="primaryGradientBgLabel"
        sx={{
          color: props.textColor,
        }}
      >
        {props.text}
      </ButtonLabel>
    </CustomButton>
  );
}

const CustomButton = styled(Button)(() => ({
  width: '48%',
  background: '#5E70CC',
  '&.Mui-disabled': {
    background: '#bec6eb',
    boxShadow: '0px 3px 6px rgb(0 0 0 / 8%)',
  },
}));

const ButtonLabel = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: '600',
  textTransform: 'capitalize',
  paddingTop: '5px',
  paddingBottom: '5px',
}));
